import { UIInlineHeading1, UIInlineHeading2, UIInlineHeading3, UIInlineHeading4, UIInlineHeading5, UIInlineHeading6 } from '../../../internal/typography/UI/UIInlineHeading';
import { UIText1, UIText2, UIText3 } from '../../../typography';
var SIZE_TO_HEADING_MAP = {
  XXL: UIInlineHeading1,
  XL: UIInlineHeading2,
  L: UIInlineHeading3,
  M: UIInlineHeading4,
  S: UIInlineHeading5,
  XS: UIInlineHeading6
};
var SIZE_TO_TEXT_MAP = {
  XXL: UIText1,
  XL: UIText1,
  L: UIText1,
  M: UIText1,
  S: UIText2,
  XS: UIText3
};
export var getTypographyComponent = function getTypographyComponent(fontSize, fontWeight) {
  return fontWeight === 'bold' ? SIZE_TO_HEADING_MAP[fontSize] : SIZE_TO_TEXT_MAP[fontSize];
};